export default __webpack_public_path__ + "static/logo-091838956c831d33e3faccc19cd81c9e.svg";